// src/components/BusinessTile.tsx
import React, { useState } from "react";
import { FaStar, FaRegStar } from "react-icons/fa";

const dayNames = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const formatTime = (time: string) => {
  const hours = parseInt(time.substring(0, time.length - 2), 10);
  const minutes = time.substring(time.length - 2);
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  return `${formattedHours}:${minutes} ${period}`;
};

interface BusinessTileProps {
  business: any; // Replace 'any' with the appropriate type
}

const BusinessTile: React.FC<BusinessTileProps> = ({ business }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return (
    <div
      key={business.id}
      className="border rounded-lg shadow-lg w-full flex max-h-64"
    >
      <img
        src={business.image_url}
        alt={business.name}
        className="w-5/12 h-auto min-h-64 object-cover rounded-l-lg"
      />
      <div className="p-4 w-2/3">
        <h2 className="text-xl font-semibold">{business.name}</h2>
        <div className="flex items-center">
          {[...Array(5)].map((_, i) =>
            i < Math.floor(business.rating) ? <FaStar /> : <FaRegStar />
          )}
          <div className="ml-1">{business.rating}</div>
          <span className="text-gray-600 ml-2">
            ({business.review_count} reviews)
          </span>
          <span className="text-gray-600 ml-2">{business.price}</span>
        </div>
        <p className="text-gray-600">{business.address}</p>
        <p className="text-gray-600">{business.phone}</p>
        <p className="text-gray-600">
          {business.categories.map((category) => (
            <span
              key={category.title}
              className="inline-block bg-gray-200 text-gray-800 text-xs font-semibold mr-2 px-2.5 py-0.5 rounded"
            >
              {category.title}
            </span>
          ))}
        </p>

        <div
          className={`transition-max-height duration-500 ease-in-out overflow-y-auto ${
            isExpanded ? "max-h-14 mt-2 " : "max-h-0"
          }`}
        >
          <table className="text-gray-600 w-full mt-2">
            <tbody>
              {dayNames.map((day, index) => (
                <tr key={index}>
                  <td className="pr-2 font-semibold">{day.substring(0, 3)}:</td>
                  <td>
                    {business.business_hours.open &&
                    business.business_hours.open.length > 0 &&
                    business.business_hours.open[0].filter(
                      (hours) => hours.day === index
                    ).length > 0 ? (
                      business.business_hours.open
                        .filter((hours) => hours.day === index)
                        .map((hours, i) => (
                          <span key={i}>
                            {`${formatTime(
                              hours.start.toString()
                            )} - ${formatTime(hours.end.toString())}`}
                            {i <
                              business.business_hours.open.filter(
                                (h) => h.day === index
                              ).length -
                                1 && ", "}
                          </span>
                        ))
                    ) : (
                      <span>Closed</span>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-start ">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-blue-500 hover:text-blue-600 mt-2"
          >
            {isExpanded ? "Hide Hours" : "Show Hours"}
          </button>
          <a
            href={business.url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block mt-2 px-4 py-2 text-blue-500 hover:text-blue-600"
          >
            View Website
          </a>
        </div>
      </div>
    </div>
  );
};

export default BusinessTile;
